import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "heart_hollow",
  "use": "heart_hollow-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"heart_hollow\"><path fill-rule=\"evenodd\" d=\"m14.086 4.917-.003-.003a3.074 3.074 0 0 0-4.376 0l-.711.72-.712-.72a3.076 3.076 0 0 0-4.375 0 3.16 3.16 0 0 0 0 4.434v.001l5.087 5.12 5.09-5.123a3.14 3.14 0 0 0 0-4.43M3.197 10.052a4.16 4.16 0 0 1 0-5.84 4.076 4.076 0 0 1 5.799 0 4.1 4.1 0 0 1 1.328-.897 4.08 4.08 0 0 1 4.47.896 4.14 4.14 0 0 1 0 5.84l-5.301 5.337a.7.7 0 0 1-.994 0z\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol